/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument, QuoteOptions } from 'paintscout'

import { getQuoteOptions } from '../../quote/util'

/**
 * Writes resolved quote options onto the quote document.
 *
 * Every key is written explicitly, and a value stored on the quote permanently beats the
 * account setting (see `getOverrideableOption`) — so the `defaults` seed must never contradict
 * the account. Pass `options` (the account OptionsDocument) so unspecified keys fall back to
 * the account value instead of `getQuoteOptions`' hardcoded defaults (#22179).
 */
export function setQuoteOptions(args: {
  quote?: QuoteDocument
  quoteOptions?: QuoteOptions
  options?: OptionsDocument
}): QuoteDocument {
  const { quoteOptions, quote, options } = args

  const defaults = getQuoteOptions({ quote, options })
  return {
    ...quote,
    options: {
      ...defaults,
      ...quoteOptions
    }
  }
}
